(function accordionInit() {
 if (document.readyState === 'loading') {
   return document.addEventListener('DOMContentLoaded', accordionInit);
 }


 var acc = document.getElementById('native-pdp-accordion');
 if (!acc || acc.dataset.accReady === '1') return;
 acc.dataset.accReady = '1';


 document.body.classList.add('accordion-revamp');


 var heads = Array.prototype.slice.call(acc.querySelectorAll('.acc-head'));
 var pages = Array.prototype.slice.call(acc.querySelectorAll('.acc-panel'));


 var openIdx = 0;


 // Height of whatever is currently pinned to the top of the viewport (sticky
 // header, plus any promo/shipping bar stacked above it) — getBoundingClientRect
 // already reflects any offset those bars push the header down by, so this is
 // the full occluded height regardless of how many bars are stacked.
 function stickyOffset() {
   var header = document.getElementById('shopify-section-header');
   if (!header) return 0;
   var pos = header.style.position || window.getComputedStyle(header).position;
   if (pos !== 'fixed' && pos !== 'sticky') return 0;
   return header.getBoundingClientRect().bottom;
 }

 // Scrolls so the given tab's own header sits just under the sticky header —
 // scrolling to the outer accordion container's top instead (as this used to)
 // shows wherever the FIRST tab's header is, not the one that was just opened.
 function scrollToTab(idx) {
   var target = heads[idx].getBoundingClientRect().top + window.pageYOffset - stickyOffset() - 200;
   window.scrollTo({ top: target, behavior: 'smooth' });
 }

 // Opens a tab without the toggle-closes-if-already-open behavior below —
 // used by the review-badge shortcut (assets/pdp-reviews.js) so clicking it
 // again while the reviews tab is already open re-scrolls instead of closing it.
 function openTab(idx) {
   if (openIdx !== idx) {
     heads.forEach(function(h) { h.classList.remove('active'); });
     pages.forEach(function(p) { p.classList.remove('active'); });
     openIdx = idx;
     heads[idx].classList.add('active');
     pages[idx].classList.add('active');
   }
   scrollToTab(idx);
 }
 window.pdpOpenAccordionTab = function (headSelector) {
   var idx = heads.findIndex(function(h) { return h.matches(headSelector); });
   if (idx !== -1) openTab(idx);
 };

 heads.forEach(function(head, idx) {
   head.addEventListener('click', function(e) {
     e.stopPropagation();
     var wasOpen = (openIdx === idx);
     heads.forEach(function(h) { h.classList.remove('active'); });
     pages.forEach(function(p) { p.classList.remove('active'); });
     if (wasOpen) {
       openIdx = -1;
     } else {
       openIdx = idx;
       heads[idx].classList.add('active');
       pages[idx].classList.add('active');
     }
     try { campaign.trigger('Clicked.' + head.textContent.trim()); } catch(e2) {}
     if (!wasOpen) scrollToTab(idx);
   });
 });


 var openFaqIdx = -1;
 Array.prototype.slice.call(acc.querySelectorAll('.faq-link')).forEach(function(link, faqIdx) {
   link.addEventListener('click', function(e) {
     e.stopPropagation();
     var li = link.parentElement;
     var siblings = Array.prototype.slice.call(li.parentElement.children);
     var wasOpen = (openFaqIdx === faqIdx);
     siblings.forEach(function(s) { s.classList.remove('faq-active'); });
     openFaqIdx = -1;
     if (!wasOpen) {
       li.classList.add('faq-active');
       openFaqIdx = faqIdx;
     }
     try { campaign.trigger('Clicked.' + link.textContent.trim()); } catch(e2) {}
     window.scrollTo(0, acc.getBoundingClientRect().top + window.pageYOffset);
   });
 });


 var sectionId = acc.getAttribute('data-section-id');
 var cartBtn = document.getElementById('AddToCart-' + sectionId);
 if (cartBtn) {
   cartBtn.addEventListener('click', function() {
     try { campaign.trigger('Clicked.addtocart'); } catch(e) {}
   });
 }


 var descEl = acc.querySelector('#tab-1 .acc-description');
 if (descEl && !descEl.querySelector('.desc-text')) {
   var full = descEl.innerHTML;
   descEl.innerHTML = '<div class="desc-text">' + full + '</div><span class="read-toggle">Read More</span>';
   var textEl   = descEl.querySelector('.desc-text');
   var toggleEl = descEl.querySelector('.read-toggle');
   setTimeout(function() {
     if (textEl.scrollHeight <= textEl.offsetHeight) toggleEl.style.display = 'none';
   }, 100);
   toggleEl.addEventListener('click', function() {
     if (textEl.classList.contains('expanded')) {
       textEl.classList.remove('expanded');
       toggleEl.textContent = 'Read More';
       try { campaign.trigger('Clicked.Read Less'); } catch(e) {}
       textEl.scrollTop = 0;
       window.scrollTo({ top: descEl.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
     } else {
       textEl.classList.add('expanded');
       toggleEl.textContent = 'Read Less';
       try { campaign.trigger('Clicked.Read More'); } catch(e) {}
     }
   });
 }
})();


